import { customCamelCase } from "@/src/lib/string";
import { Practitioner } from "@/src/models/practitioner";

export const fullPractitionerSelect = `
  *
`;

export function mapPractitionerRowToPractitioner(practitionerRow: any): Practitioner {
  const mappedFields: Record<string, any> = {};

  for (const [key, value] of Object.entries(practitionerRow)) {
    if (key === "canonical_npi_number") {
      continue;
    }

    mappedFields[customCamelCase(key)] = value;
  }

  return {
    ...mappedFields,
  } as Practitioner;
}
